'use strict';

class ProcedureController {
    /* @ngInject */
    constructor($scope) {
        let procedure = $scope.$parent.$resolve.procedure;
        this.procedure = procedure;
    }
}

export default ProcedureController;
